import { Asset } from 'app-lib/assetUtils'
import { TokenBalances } from 'bzx-common/src/stores/StakingStore/UserBalances'
import { observer } from 'mobx-react'
import React from 'react'
import AssetBalance from 'shared-components/AssetBalance'
import { ookiToken } from 'bzx-common/src/config/appConfig'

export function Balances({ wallet }: { wallet: TokenBalances }) {
  return (
    <>
      <AssetBalance className="margin-bottom-2" balance={wallet.ooki} asset={Asset.OOKI} />

      <AssetBalance className="margin-bottom-2" balance={wallet.vbzrx} asset={Asset.vBZRX} />

      <AssetBalance className="margin-bottom-2" balance={wallet.iooki} asset={Asset.IOOKI} />

      <AssetBalance
        balance={wallet.slp_ooki_eth}
        link={ookiToken.slp.sushiPoolLink}
        asset={Asset.SLP_OOKI_ETH}
      />
    </>
  )
}

export default observer(Balances)
